import { getFormValues } from 'redux-form';
import moment from 'moment';

const TOGGLE_PAYOUT_DATE_POPUP_VISIBLE = `payoutsList/TOGGLE_PAYOUT_DATE_POPUP_VISIBLE`;
const INIT_PAYOUT_DATE_POPUP = `payoutsList/INIT_PAYOUT_DATE_POPUP`;

// initState
const initialState = {
	isPaymentDatePopupVisible: false,
	paidAtFormPendingPayout: {}
};

// actions
const actions = {
	initPaymentDatePopup: (selectedPayouts, partially) => ({
		type: INIT_PAYOUT_DATE_POPUP,
		payload: { selectedPayouts, partially }
	}),
	togglePaymentDatePopup: () => ({
		type: TOGGLE_PAYOUT_DATE_POPUP_VISIBLE
	})
};

// reducers
const reducers = {
	[TOGGLE_PAYOUT_DATE_POPUP_VISIBLE]: (state) => ({
		...state,
		isPaymentDatePopupVisible: !state.isPaymentDatePopupVisible
	}),
	[INIT_PAYOUT_DATE_POPUP]: (state, action) => ({
		...state,
		paidAtFormPendingPayout: action.payload,
		isPaymentDatePopupVisible: true
	})
};

// selectors
const selectors = {
	getIsPaymentDatePopupVisible: state => state.payoutsList.isPaymentDatePopupVisible,
	getpaidAtFormPendingPayout: state => state.payoutsList.paidAtFormPendingPayout,
	getPayedAt: state => {
		const paymentAtFormDate = getFormValues('paymentAtForm')(state);
		if (!paymentAtFormDate || !paymentAtFormDate.date) return null;

		const date = paymentAtFormDate.date.format('YYYY-MM-DD');
		if (paymentAtFormDate.time) {
			return moment(`${date} ${paymentAtFormDate.time}`)
				.tz(state.root.data.timezone)
				.format('YYYY-MM-DDTHH:mm:ssZ');
		}
		return date;
	}
};

export default {
	initialState,
	actions,
	reducers,
	selectors
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/popups/payment-date/index.js